// Formatação de dinheiro currency-aware. O banco grava SEMPRE em menor unidade
// inteira (centavos); aqui dividimos por 100 (BRL/USD/EUR têm 2 casas) e formatamos
// pela moeda da conta via Intl.NumberFormat. Substitui o `brl()` hardcoded que
// estava espalhado pelas páginas.

const LOCALE_BY_CCY: Record<string, string> = { BRL: 'pt-BR', USD: 'en-US', EUR: 'de-DE' };

// formatMoney formata centavos (menor unidade inteira) na moeda informada.
export function formatMoney(cents: number, currency = 'BRL'): string {
  const ccy = (currency || 'BRL').toUpperCase();
  const locale = LOCALE_BY_CCY[ccy] ?? 'en-US';
  return new Intl.NumberFormat(locale, { style: 'currency', currency: ccy }).format(cents / 100);
}

// brl: atalho legado p/ telas ainda mono-moeda (vão para formatMoney por-moeda na F6).
export const brl = (cents: number) => formatMoney(cents, 'BRL');
